import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Customer, { BlockedCustomer } from "../../../models/Customer";
import { useBlockCustomer } from "../../../networking/consultant.hooks";
import { useAllCustomers } from "../../../networking/customer.hooks";
import AppText from "../../Core/AppText/AppText";
import Button, { ButtonStyleProps } from "../../Core/Button/Button";
import Dropdown from "../../Core/Dropdown/Dropdown";
import Modal from "../../Core/Modal/Modal";
import TextArea from "../../Core/TextArea/TextArea";
import Flex from "../../Layout/Flex";
import { useConfirmModalStore } from "../../../stores/confirmModal.store";

interface ModalStyles {
	primaryActionButton?: ButtonStyleProps;
	secondaryActionButton?: ButtonStyleProps;
}

interface Props {
	consultantId: string;
	onClose: () => void;
	blockedCustomers: BlockedCustomer[];
}

const CustomerBlockModal: React.FC<Props> = ({ consultantId, onClose, blockedCustomers }) => {
	const modalStore = useConfirmModalStore();
	const { modalData } = modalStore;
	const [selectedCustomer, setSelectedCustomer] = useState("");
	const [comment, setComment] = useState("");

	const { t } = useTranslation();

	const [modalStyle, setModalStyle] = useState<ModalStyles>();

	const { customers } = useAllCustomers();
	const { mutate: blockCustomer, isLoading: isBlocking } = useBlockCustomer();

	useEffect(() => {
		const defaultGrayButton: ButtonStyleProps = {
			backgroundColor: "dividerGray",
			textColor: "black",
		};

		switch (modalData.type) {
			case "DANGER":
				setModalStyle({
					primaryActionButton: {
						backgroundColor: "danger",
						textColor: "white",
					},
					secondaryActionButton: {
						...defaultGrayButton,
					},
				});
				break;
			default:
				setModalStyle({
					secondaryActionButton: {
						...defaultGrayButton,
					},
				});
		}
	}, [modalData.type]);

	function handleSubmit() {
		if (selectedCustomer) {
			// The mutation invalidates the blocked-customers query on success
			// and toasts on error.
			blockCustomer(
				{ consultantId, customerId: selectedCustomer, comment },
				{ onSuccess: () => onClose() }
			);
		}
	}

	const getOptions = () => {
		const blockedCustomerIds = blockedCustomers.map((c) => c.customer.id);
		return [...customers]
			.sort((a, b) => a.name.localeCompare(b.name))
			.filter((item) => !blockedCustomerIds.includes(item.id));
	};

	return (
		<Modal maxWidth="600px" overflowY="visible">
			<AppText size="xm" weight="bold">
				{t("CUSTOMER_BLOCK")}
			</AppText>

			<Flex width="90%" direction="column">
				<Dropdown<Customer>
					label="CUSTOMER"
					name="customer"
					options={getOptions()}
					placeholder="SELECT_CUSTOMER"
					getOptionLabel={(customer: Customer) => customer.name}
					getValue={(o) => o.id}
					onChange={setSelectedCustomer}
					margin="1.5rem 0 1rem 0"
				/>

				<TextArea
					label="customerBlock.comment"
					value={comment}
					onChangeText={setComment}
					containerMargin="0 0 2rem 0"
				/>
			</Flex>

			<Button
				width="12.625rem"
				{...modalStyle?.primaryActionButton}
				margin="0 0 0.5rem 0"
				onClick={handleSubmit}
				disabled={!selectedCustomer || isBlocking}
			>
				{t("SAVE")}
			</Button>
			<Button width="12.625rem" {...modalStyle?.secondaryActionButton} onClick={onClose}>
				{t("CANCEL")}
			</Button>
		</Modal>
	);
};
export default CustomerBlockModal;

// TODO: Isn't there a base for modals already? If so change to that. /JS
// const ModalContainer = styled.div`
// 	position: fixed;
// 	z-index: 1000;
// 	top: 0;
// 	left: 0;
// 	width: 100%;
// 	height: 100%;
// 	display: flex;
// 	align-items: center;
// 	background: rgba(0, 0, 0, 0.6);
// 	overflow-y: auto;
// `;

// const ModalWrapper = styled.section`
// 	background: white;
// 	width: 100%;
// 	max-width: 32.5rem;
// 	margin: 10em auto 5em auto;
// 	height: auto;
// 	align-items: center;
// 	border-radius: 10px;
// 	display: flex;
// 	flex-direction: column;
// 	padding: 3.125rem;
// `;
